module.exports = __webpack_public_path__ + "a6a0a78ea36b492f5f6c64100aa33354.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/features_rocket.png
// module id = Oz6Z
// module chunks = 5